import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#e5dfe9] pt-24 pb-16">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <div className="h-px w-24 bg-neutral-500/40 mx-auto mb-8" />
        <p className="font-serif italic text-neutral-700 text-sm">
          &copy; {new Date().getFullYear()} Urban Outsourcing. Work is its own reward.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
